class WebSessionLabelModel {
    static entityType = 59;
    static create = (json) => new WebSessionLabelModel(json);
    
    constructor(json) {
        if (!json) json = {};
        
        this.id = json.id || null;
        
        this.userId = json.user_id || null;
        this.companyId = json.company_id || null;
        this.webSessionId = json.web_session_id || null;
        this.name = json.name || null;
        this.status = json.status || 0;
        
        this.created = !!json.created ? new Date(json.created) : null;
        this.modified = !!json.modified ? new Date(json.modified) : null;
    }
    
    toJson() {
        return {
            user_id: this.userId,
            company_id: this.companyId,
            web_session_id: this.webSessionId,
            name: this.name,
        };
    }

    searchFor(term) { 
        if (typeof term === "number") term = term.toString();
        if (!term) return true;
        
        term = term.toLowerCase();
        
        if (this.webSessionId?.toString().toLowerCase().indexOf(term) >= 0) return true;
        if (this.name?.toString().toLowerCase().indexOf(term) >= 0) return true;
        
        return (term === this.id?.toLowerCase());
    }
    
    static fromJsonArray(jsonArray) {
        if (!jsonArray || !Array.isArray(jsonArray)) return [];
        return jsonArray.map(json => WebSessionLabelModel.create(json));
    }
}

export default WebSessionLabelModel;
